import * as React from "react";
import styled from "@mui/material/styles/styled";
import { DesktopOnly } from "../util/desktopOnly";
import { SubCategoryChip } from "../common/SubCategoryChip";
import { Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { DataInputPanel } from "../../dataInputTypes";
import { MobileView } from "../../../util/aKaunGeneralUtil";
import { MobileOnly } from "../util/mobileOnly";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

//region [[ Styles ]]

const PanelsSubCategorySelectView = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginBottom: theme.spacing(1),
  [theme.breakpoints.down(MobileView)]: {
    marginBottom: theme.spacing(0),
  },
}));

const SelectStyled = styled(Select)(({ theme }) => ({
  height: "30px",
  fontSize: "14px",
  lineHeight: "16px",
  fontWeight: 500,
  borderColor: "none",
  color: KahunColorMap.PrimaryDim,
  "& .MuiSelect-outlined": {
    padding: 0,
    paddingRight: "30px",
  },
  "& .MuiSelect-select:focus": {
    backgroundColor: "unset",
  },
  "& svg": {
    color: KahunColorMap.PrimaryDim,
  },
  "& fieldset": {
    border: "none",
  },
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface PanelsSubCategorySelectProps {
  subCategories: DataInputPanel[];
  selectedPanelId: any;

  selectPanel: any;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PanelsSubCategorySelect = ({
  ...props
}: PanelsSubCategorySelectProps) => {
  return (
    <PanelsSubCategorySelectView>
      {props.subCategories.length > 1 && (
        <>
          <DesktopOnly>
            {props.subCategories.map((p) => (
              <SubCategoryChip
                key={p.id}
                id={p.id}
                label={p.title}
                selected={props.selectedPanelId === p.id}
                onClick={props.selectPanel(p)}
              />
            ))}
          </DesktopOnly>

          <MobileOnly>
            <SelectStyled
              variant="outlined"
              value={props.selectedPanelId}
              IconComponent={ExpandMoreIcon}
            >
              {props.subCategories.map(
                (p) =>
                  p && (
                    <MenuItem
                      key={p.id}
                      value={p.id}
                      onClick={props.selectPanel(p)}
                    >
                      {p.title}
                    </MenuItem>
                  ),
              )}
            </SelectStyled>
          </MobileOnly>
        </>
      )}
    </PanelsSubCategorySelectView>
  );
};
